import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: '"Gill Sans", "Gill Sans Light", "Lato", "sans-serif"',
    h1: {
      fontFamily: '"Gill Sans", "Gill Sans Light", "Lato", "sans-serif"',
    },
    h2: {
      fontFamily: '"Gill Sans", "Gill Sans Light", "Lato", "sans-serif"',
    },
    h3: {
      fontFamily: '"Gill Sans", "Gill Sans Light", "Lato", "sans-serif"',
    },
    h4: {
      fontFamily: '"Gill Sans", "Gill Sans Light", "Lato", "sans-serif"',
    },
    h5: {
      fontFamily: '"Gill Sans", "Gill Sans Light", "Lato", "sans-serif"',
    },
    h6: {
      fontFamily: '"Gill Sans", "Gill Sans Light", "Lato", "sans-serif"',
    },
    body1: {
      fontFamily: '"Gill Sans", "Gill Sans Light", "Lato", "sans-serif"',
    },
    body2: {
      fontFamily: '"Gill Sans", "Gill Sans Light", "Lato", "sans-serif"',
    },
  },
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          fontFamily: '"Gill Sans", "Gill Sans Light", "Lato", "sans-serif"',
        },
      },
    },
  },
});

export default theme;
